import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from "@angular/platform-browser";
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DeptCategoryPickerComponent } from './dept-category-picker.component';
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PopoverModule } from "ngx-bootstrap/popover";
import { FormsModule } from "@angular/forms";
import {
    DropdownModule,
    ButtonModule,
    CheckboxModule,
    InputsModule
  } from '@xref/xref-lib';


@NgModule({
    declarations: [DeptCategoryPickerComponent],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        ModalModule,
        BrowserAnimationsModule,
        BsDatepickerModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        DropdownModule,
        CheckboxModule,
        ButtonModule,
        InputsModule
    ],
    exports: [DeptCategoryPickerComponent]
})
export class DeptCategoryPickerModule { }
